import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { authUtils } from '@lib/api';

const isAuthenticated = () => localStorage.getItem('auth_token') !== null;
const isAdminUser = () => {
  try {
    const user = authUtils.getUser();
    return user?.role === 'admin' || user?.role === 'super_admin';
  } catch {
    return false;
  }
};

export const ProtectedRoute = ({ children }: { children: ReactNode }) => {
  const params = new URLSearchParams(window.location.search);
  const arid = params.get('auth_request_id');
  if (isAuthenticated()) {
    // Already logged in but a pending OIDC flow (arid) exists → resume it and
    // return to the calling app via consent, WITHOUT changing the current session.
    if (arid) return <Navigate to={`/consent?auth_request_id=${encodeURIComponent(arid)}`} replace />;
    return <>{children}</>;
  }
  // Not authenticated: preserve arid when redirecting to login.
  return <Navigate to={arid ? `/login?auth_request_id=${encodeURIComponent(arid)}` : '/login'} replace />;
};
export const PublicRoute = ({ children }: { children: ReactNode }) => {
  // OIDC flow: allow access to login/consent even when already authenticated
  const params = new URLSearchParams(window.location.search);
  if (isAuthenticated() && params.get('auth_request_id')) return <>{children}</>;
  return !isAuthenticated() ? <>{children}</> : <Navigate to="/identities" replace />;
};

// Admin routes - require login + admin role
export const AdminProtectedRoute = ({ children }: { children: ReactNode }) => {
  if (!isAuthenticated()) return <Navigate to="/login" replace />;
  if (!isAdminUser()) return <Navigate to="/identities" replace />;
  return <>{children}</>;
};

// Admin login page - redirect to main login (no public admin entry)
export const AdminPublicRoute = ({ children: _children }: { children: ReactNode }) => {
  return <Navigate to="/login" replace />;
};
